import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Text from '@zg-rentals/multibrand-ui/lib/Text';

// Stylesheets
import './style.scss';

const propTypes = {
    previews: PropTypes.array.isRequired,
};

const defaultPropTypes = {
    previews: [],
};

function BoostAdPreview({ title, body }) {
    // Would be ideal to set the height programmatically, but the iframe document can't be accessed
    const newBody = body.replace(/height="\d*"/, 'height="580px"').replace(/scrolling="yes"/, '/scrolling="no"/');

    return (
        <div>
            <Text className="BoostAdPreviews-title" type="h4" uppercase={true} emphasize={true}>
                {title}
            </Text>
            <div dangerouslySetInnerHTML={{ __html: newBody }} />
        </div>
    );
}

function BoostAdPreviews({ previews }) {
    return (
        <div className="BoostAdPreviews">
            {previews.map(preview => (
                <BoostAdPreview
                    key={preview.cpmBoostType}
                    title={preview.cpmBoostType}
                    body={preview.body}
                />
            ))}
        </div>
    );
}

BoostAdPreviews.propTypes = propTypes;
BoostAdPreviews.defaultPropTypes = defaultPropTypes;

export default BoostAdPreviews;
